import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateSubmittedPostDto, SubmittedPostDto } from '../../common/general-types/submitted-posts.dto';

@Injectable({
  providedIn: 'root'
})
export class SubmittedPostsService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  getInvalidSubmittedPostsForShoutBriefId(shoutBriefId: string) {
    const invalid_submitted_posts_url = `${environment.shout_api.url}/submitted-posts/shoutbrief/${shoutBriefId}/invalid`;
    return this.http.get<SubmittedPostDto[]>(invalid_submitted_posts_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getValidSubmittedPostsForShoutBriefId(shoutBriefId: string, platform: number | undefined) {
    const sup_posts_url = platform !== undefined && platform !== -1 ? `/submitted-posts/by-shout-brief-id/${shoutBriefId}/${platform}` : `/submitted-posts/shoutbrief/${shoutBriefId}`;

    console.log('---> valid_submitted_posts_url: ', `${environment.shout_api.url}${sup_posts_url}`);

    const valid_submitted_posts_url = `${environment.shout_api.url}${sup_posts_url}`;
    return this.http.get<SubmittedPostDto[]>(valid_submitted_posts_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  createSubmittedPost(createPost: CreateSubmittedPostDto) {
    const create_submitted_post_url = `${environment.shout_api.url}/submitted-posts`;
    return this.http.post<SubmittedPostDto>(create_submitted_post_url, createPost, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  getSubmittedPostsForBriefApplication(briefApplicationId: string) {
    const submitted_posts_for_brief_application_url = `${environment.shout_api.url}/submitted-posts/brief-application/${briefApplicationId}`;
    return this.http.get<SubmittedPostDto[]>(submitted_posts_for_brief_application_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getModernBriefApplicationSinglePost(briefApplicationId: string, videoId: string) {
    const modern_brief_application_single_post_url = `${environment.shout_api.url}/submitted-posts/brief-application-single-post/${briefApplicationId}/${videoId}`;
    return this.http.get<SubmittedPostDto>(modern_brief_application_single_post_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  revalidateLink(submittedPostId: string) {
    const revalidate_link_url = `${environment.shout_api.url}/submitted-posts/${submittedPostId}/validate`;
    return this.http.post(revalidate_link_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  pushThrough(briefApplicationId: string) {
    const push_through_url = `${environment.shout_api.url}/submitted-posts/brief-application/${briefApplicationId}/push-through`;
    return this.http.post(push_through_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  updateVideoLink(submittedPostId: string, videoLink: string, adCode?: string) {
    console.log('updateVideoLink()');
    console.log('submittedPostId: ', submittedPostId);
    console.log('videoLink: ', videoLink);
    console.log('adCode: ', adCode);
    const body: any = { submittedPostId: submittedPostId, videoLink: videoLink };
    if (adCode) {
      body.adCode = adCode;
    }

    console.log('body: ', body);
    return this.http.post(`${environment.shout_api.url}/submitted-posts/update-video`, body, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  patchSubmittedPost(
    submittedPostId: string,
    patch: Pick<SubmittedPostDto, 'fullUrl' | 'videoLink' | 'adCode'>,
  ) {
    return this.http.patch<SubmittedPostDto>(
      `${environment.shout_api.url}/submitted-posts/${submittedPostId}`,
      patch,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  resolveVideoLink(videoLink: string, socialChannel: number) {
    return this.http.post<{
      fullUrl: string;
      linkHandle?: string | null;
      extractedVideoId?: string | null;
    }>(
      `${environment.shout_api.url}/submitted-posts/resolve-video-link`,
      { videoLink, socialChannel },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  /**
   * Manually trigger the full cross-channel payment cycle (wallet transaction +
   * payout + Airwallex transfer) for an already-existing submitted post. The
   * server owns all amount/currency computation and idempotency.
   */
  payForSubmittedPost(submittedPostId: string) {
    const pay_url = `${environment.shout_api.url}/scheduled-tasks/submitted-post/${submittedPostId}/pay`;
    return this.http.post<unknown>(pay_url, {}, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  /**
   * Admin-only "Pay anyway" override: forces the cross-channel payment through even
   * when the business wallet has insufficient balance, pushing the wallet ledger
   * negative. The server gates this behind finance/payout/god-mode roles.
   */
  forcePayForSubmittedPost(submittedPostId: string) {
    const force_pay_url = `${environment.shout_api.url}/scheduled-tasks/submitted-post/${submittedPostId}/pay/force`;
    return this.http.post<unknown>(force_pay_url, {}, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
